export const SERVICE_PRICES = {
  "Stage 1 Remap": 200,
  "EGR Delete": 150,
  "AdBlue Delete": 150,
  "DPF Delete": 150,
};

export const baseForBooking = (vehicle, stage) => {
  const hay = vehicle || (stage ? `General enquiry — ${stage}` : "");
  if (!hay) return null;
  for (const [name, price] of Object.entries(SERVICE_PRICES)) {
    if (hay.includes(name)) return price;
  }
  if (hay.includes("Stage 1:")) return 200;
  return null;
};

export const applyDiscount = (base, promo) => {
  if (!promo || !promo.discount_type || !promo.discount_value) return base;
  if (promo.discount_type === "percent") {
    return Math.max(0, Math.round(base * (1 - promo.discount_value / 100)));
  }
  if (promo.discount_type === "fixed") {
    return Math.max(0, base - promo.discount_value);
  }
  return base;
};
